import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PortfolioDetailComponent} from './portfolio-detail.component';

const routes: Routes = [{
    path: '',
    pathMatch: 'full',
    component: PortfolioDetailComponent
}];


@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class PortfolioDetailRoutingModule {
}